import styled from 'styled-components';

export const ProgressBarContainer = styled.div`
  height: 8px;
  width: 100px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.palette.grey300};
  overflow: hidden;
`;

export const Filler = styled.div<{ progress?: number }>`
  height: 100%;
  background-color: ${({ theme }) => theme.palette.grey800};
  width: ${({ progress }) => `${progress}%`};y
  transition: width 0.2s ease-in;
  border-radius: 3px;
`;
